import React, { useState, useRef, useEffect } from "react";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import Form1 from "../ColdWorkPermit/Form1";
import Form2 from "../ColdWorkPermit/Form2";
import Form3 from "../ColdWorkPermit/Form3";
import API_URL from "../../src/Config";
import axios from "axios";
import { Tabs, Tab } from "@mui/material";
import IssuerAllDepartmentForms from "../RoadClosureWorkPermit/IssuerAllDepartmentForms";
import AdditionalPrecaution from "../RoadClosureWorkPermit/AdditionalPrecaution";

function PermitRequestEditTab({ isSidebarExpanded }) {
  const containerRef = useRef(null);
  const navigate = useNavigate();
  const location = useLocation();
  const { permit_id, permit_type_id } = useParams();
  // const { permit_id } = location?.state?.permit_id || {};
  // const { permit_type_id } = location?.state?.permit_type_id || {};

  const queryParams = new URLSearchParams(location.search);
  const tabFromUrl = queryParams.get("tab");

  const [tabValue, setTabValue] = useState(tabFromUrl || "Work Permit Details");
  const [tabStatus, setTabStatus] = useState({
    isCheckListCompleted: false,
    isPrecautionCompleted: false,
    isAdditionalPrecautionCompleted: false,
    isAllDepartmentCompleted: false,
    isWorkDetailsCompleted: true,
  });

  console.log("permit_id", permit_id);
  console.log("permit_type_id", permit_type_id);

  useEffect(() => {
    if (tabFromUrl && tabFromUrl !== tabValue) {
      setTabValue(tabFromUrl);
    }
  }, [location.search]);

  const handleTabChange = (event, newValue) => {
    if (isTabAccessible(newValue)) {
      setTabValue(newValue);
      navigate(`?tab=${newValue}`);
    }
  };

  const isTabAccessible = (tabName) => {
    switch (tabName) {
      case "Work Permit Details":
        return tabStatus.isWorkDetailsCompleted;
      case "Checklist Items":
        return tabStatus.isCheckListCompleted;
      case "Hazards Precautions":
        return tabStatus.isPrecautionCompleted;
      case "Departments":
        return tabStatus.isAllDepartmentCompleted;
      case "Additional Precautions":
        return tabStatus.isAdditionalPrecautionCompleted;
      default:
        return true;
    }
  };

  const fetchComplitionSatusData = async () => {
    try {
      const authKey = localStorage.getItem("authKey");

      const response = await axios.get(
        `${API_URL}/api/get_permit_completion_status/${permit_id}`,
        {
          headers: {
            Authorization: authKey,
          },
        }
      );
      console.error("response.data----------:", response.data);

      setTabStatus({
        isCheckListCompleted: response.data.isCheckListCompleted,
        isPrecautionCompleted: response.data.isPrecautionCompleted,
        isWorkDetailsCompleted: response.data.isWorkDetailsCompleted,
      });
    } catch (error) {
      console.error("Error fetching tab status:", error.message);
    }
  };

  useEffect(() => {
    fetchComplitionSatusData();
  }, []);

  return (
    <>
      <div
        className={`data-list-content-container page-content ${
          isSidebarExpanded ? "expanded" : "collapsed"
        }`}
      >
        <div className="data-list-content" ref={containerRef}>
          {permit_type_id === "e32d9e81-a68c-11f0-81e8-9c2dcdaf01ba" ? (
            <>
              <Tabs
                value={tabValue}
                onChange={(event, newValue) => handleTabChange(event, newValue)}
                aria-label="report tabs"
                className="tabs-container"
                style={{ marginBottom: "0px" }}
              >
                <Tab
                  label={
                    <div className="tab-label">
                      Work Permit Details
                      {tabStatus.isWorkDetailsCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Work Permit Details"
                  disabled={!tabStatus.isWorkDetailsCompleted}
                />
                <Tab
                  label={
                    <div className="tab-label">
                      Departments
                      {tabStatus.isAllDepartmentCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Departments"
                  // disabled={!tabStatus.isAllDepartmentCompleted}
                />
                <Tab
                  label={
                    <div className="tab-label">
                      Additional Precautions
                      {tabStatus.isAdditionalPrecautionCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Additional Precautions"
                  disabled={!tabStatus.isAdditionalPrecautionCompleted}
                />
              </Tabs>
              <div className="header-separater"></div>
              <div className="tabs-content">
                {tabValue === "Work Permit Details" && (
                  <Form1
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
                {tabValue === "Departments" && (
                  <IssuerAllDepartmentForms
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
                {tabValue === "Additional Precautions" && (
                  <AdditionalPrecaution
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
              </div>
            </>
          ) : (
            <>
              <Tabs
                value={tabValue}
                onChange={(event, newValue) => handleTabChange(event, newValue)}
                aria-label="report tabs"
                className="tabs-container"
              >
                <Tab
                  label={
                    <div className="tab-label">
                      Work Permit Details
                      {tabStatus.isWorkDetailsCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Work Permit Details"
                  disabled={!tabStatus.isWorkDetailsCompleted}
                />
                <Tab
                  label={
                    <div className="tab-label">
                      Checklist Items
                      {tabStatus.isCheckListCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Checklist Items"
                  disabled={!tabStatus.isCheckListCompleted}
                />
                <Tab
                  label={
                    <div className="tab-label">
                      Hazards & Precautions
                      {tabStatus.isPrecautionCompleted && (
                        <span className="status-icon">✔</span>
                      )}
                    </div>
                  }
                  value="Hazards Precautions"
                  disabled={!tabStatus.isPrecautionCompleted}
                />
              </Tabs>
              <div className="header-separater"></div>
              <div className="tabs-content">
                {tabValue === "Work Permit Details" && (
                  <Form1
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
                {tabValue === "Checklist Items" && (
                  <Form2
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
                {tabValue === "Hazards Precautions" && (
                  <Form3
                    permit_id={permit_id}
                    permit_type_id={permit_type_id}
                    fetchComplitionSatusData={fetchComplitionSatusData}
                  />
                )}
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
}

export default PermitRequestEditTab;
